<div class="modal-header">
  <h4 class="modal-title">Select Refund Amount</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="serverError !== null">
  <h2>Server error: {{ serverError }}</h2>
</div>

<div class="modal-body" *ngIf="serverError === null">

  <div class="alert alert-warning" *ngIf="payment.pending_refund_amount != null">
    A refund of {{ orgConfig.formatCurrency(payment.pending_refund_amount) }} for this payment is awaiting confirmation from MX Merchant.
    Capitan will record it automatically once MX Merchant confirms it; the payment cannot be refunded again until then.
  </div>

  <div class="alert alert-danger">
    Refunding this payment from the Payments list will not affect the product purchased or impact its status in Capitan.
    <br><br>
    If you wish to cancel and remove the purchased product, you must do that separately. For example, a membership may be cancelled and refunded using "Manage" in the Memberships & Passes list.
  </div>

  <p>
    Total amount paid: <b>{{ orgConfig.formatCurrency(payment.amount - payment.amount_refunded) }}</b>
  </p>

  <div class="form-group" *ngIf="payment.pending_refund_amount == null">
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="isPartialRefund"
             id="isPartialRefundFalse"
             [value]="false"
             [(ngModel)]="isPartialRefund">
      <label class="form-check-label" for="isPartialRefundFalse">
        Fully refund payment
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio"
             name="isPartialRefund"
             id="isPartialRefundTrue"
             [value]="true"
             [(ngModel)]="isPartialRefund">
      <label class="form-check-label" for="isPartialRefundTrue">
        Partially refund payment
      </label>
    </div>
  </div>

  <div class="form-group" *ngIf="isPartialRefund && (payment.pending_refund_amount == null)">
    <label for="amount">Amount to refund</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">{{ orgConfig.getCurrencySymbol() }}</span>
      </div>
      <input type="number" class="form-control" id="amount"
             min="0.01" step="0.01"
             [(ngModel)]="amount">
    </div>
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
  <button type="button" class="btn btn-primary"
          *ngIf="!loading && !serverError && (payment.pending_refund_amount == null)"
          (click)="onSubmit()">
    Refund
  </button>
  <button type="button" class="btn btn-primary disabled" disabled
          *ngIf="loading">
    Loading...
  </button>
</div>
